var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutomaticKnowdemands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.925 17.1h2.15l.3-1.525q.275-.125.525-.263.25-.137.525-.312l1.475.45 1.075-1.825-1.175-1q.025-.325.025-.625t-.025-.625l1.175-1L15.9 8.55 14.425 9q-.275-.175-.525-.312-.25-.138-.525-.263l-.3-1.525h-2.15l-.3 1.525q-.275.125-.525.263-.25.137-.525.312L8.1 8.55l-1.075 1.825 1.175 1q-.025.325-.025.625t.025.625l-1.175 1L8.1 15.45 9.575 15q.275.175.525.312.25.138.525.263ZM12 13.95q-.8 0-1.375-.575T10.05 12q0-.8.575-1.375T12 10.05q.8 0 1.375.575T13.95 12q0 .8-.575 1.375T12 13.95ZM5.075 21.2q-.95 0-1.612-.662-.663-.663-.663-1.613V5.075q0-.95.663-1.613.662-.662 1.612-.662h13.85q.95 0 1.613.662.662.663.662 1.613v13.85q0 .95-.662 1.613-.663.662-1.613.662Zm0-2.275h13.85V5.075H5.075v13.85Zm0-13.85v13.85-13.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomaticKnowdemands);
export default __webpack_public_path__ + "static/media/automatic_knowdemands.bfbd9a412beb216f12752b8e3834c3ab.svg";
export { ForwardRef as ReactComponent };